import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'RRTruncate' })
export class RRTruncatePipe implements PipeTransform {
  transform(value: string, length: number, fillString: string = '...'): string {
    if (!value || !length || value.length <= length) {
      return value;
    } else {
      return value.substr(0, length) + fillString;
    }
  }
}
